import React, { useEffect, useState } from "react";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  useFormikContext,
  useField,
} from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import draftToHtml from "draftjs-to-html";

import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import "../../css/admin/createContent.scss";
import Header from "./components/Header";
import AdminSidebar from "./components/Sidebar";
import Loading from "./components/Loading";
import apiClient from "../../api/clinet";

interface Props {}
const CreatePost: React.FC<Props> = (Props) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [images, setImages] = useState<File[]>([]);
  const [imagesNames, setImagesNames] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  var newImageState: File[] = [];
  var newImageNameState: string[] = [];

  let history = useNavigate();

  const initialValues = {
    title: "",
    postText: "",
    date: "",
  };

  interface ISubmitedData {
    title: string;
    postText: string;
    date: string;
  }

  const onFormSubmit = (submitedData: ISubmitedData) => {
    apiClient.post("/gallery", submitedData).then((response) => {
      const formData = new FormData();
      for (let i = 0; i < images.length; i++) {
        formData.append("file", images[i]);
        formData.append("name", imagesNames[i]);
        formData.append("galleryId", response.data.id);
      }

      try {
        apiClient.post("/Gallery/media", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        setIsLoading(false);
        history("../admin/adminpanel");
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    });
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("You must input a Title!"),
    postText: Yup.string().required("you must enter the Gallery text").min(12),
    date: Yup.object().required("date must be picked"),
  });

  const handleEditorChange = (state: EditorState) => {
    setEditorState(state);
  };

  interface IEditorProps {
    placeholder: string;
    name: string;
    id: string;
    className: string;
    editorState: EditorState;
    wrapperClassName: string;
    editorClassName: string;
    onEditorStateChange: { (state: any): void };
  }

  const EditorField = ({ ...props }: IEditorProps) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
      // @ts-ignore
      <Editor
        {...field}
        {...props}
        onChange={(val) => {
          setFieldValue(
            field.name,
            draftToHtml(convertToRaw(editorState.getCurrentContent()))
          );
        }}
      />
    );
  };

  interface IDateProps {
    name: string;
    locale: string;
    id: string;
    inputPlaceholder: string;
  }
  const DatePickerField = ({ ...props }: IDateProps) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
      <DatePicker
        {...field}
        {...props}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
      />
    );
  };

  const onImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.currentTarget.files) return;
    for (let i = 0; i < event.currentTarget.files.length; i++) {
      newImageState[i] = event.currentTarget.files[i];
      newImageNameState[i] = event.currentTarget.files[i].name;
    }
    setImages(newImageState);
    setImagesNames(newImageNameState);
  };

  return (
    <div className="createPostPage">
      <AdminSidebar />

      <div className="leftColumn">
        <Header />

        <Formik
          initialValues={initialValues}
          onSubmit={onFormSubmit}
          validationSchema={validationSchema}
        >
          <Form className="formContainer">
            <div className="titleContainer">
              <label htmlFor="title" className="label">
                عنوان گالری:
              </label>
              <ErrorMessage name="title" component="span" />
              <Field
                className="titleField"
                autoComplete="off"
                id="title"
                name="title"
                placeholder="(Ex. Title...)"
              />
            </div>

            <div className="dateImageContainer">
              <div className="dateContainer">
                <label htmlFor="date" className="label">
                  تاریخ گالری:
                </label>
                <ErrorMessage name="date" component="span" />

                <DatePickerField
                  name="date"
                  locale="fa"
                  id="date"
                  inputPlaceholder="انتخاب تاریخ"
                />
              </div>

              <div className="imageContainer">
                <label className="label">عکس های گالری: </label>
                <label htmlFor="file" className="imageLabel">
                  {"انتخاب عکس"}
                </label>
                <input
                  id="file"
                  name="file"
                  type="file"
                  multiple
                  className="imageField"
                  onChange={onImageChange}
                />
                {imagesNames ? (
                  <h4>{"عکس های بارگزاری شده: " + `${imagesNames.length}`}</h4>
                ) : (
                  <h4>{`هیچ عکسی بارگزاری نشده است`}</h4>
                )}
              </div>
            </div>

            <div className="editorContainer">
              <ErrorMessage name="postText" component="span" />
              <EditorField
                placeholder="Write Your Content..."
                name="postText"
                id="postText"
                className="editor"
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={handleEditorChange}
              />

              <textarea
                className="editorDisplay"
                disabled
                value={draftToHtml(
                  convertToRaw(editorState.getCurrentContent())
                )}
              />
            </div>

            <div className="buttonContainer">
              <button className="button button1" type="submit">
                ایجاد گالری
              </button>
            </div>
          </Form>
        </Formik>
      </div>
      <Loading isLoading={isLoading} />
    </div>
  );
};

export default CreatePost;
